export default __webpack_public_path__ + "static/seat_white-86806c6368550801b3f0479609a638b0.jpg";